import { createContext } from 'react';

// Create a new context
const AnalyticsContext = createContext();

export default AnalyticsContext;
